<template>
  <b-modal
    header-close-content=""
    v-model="isOpen"
    @close="hideDialog"
    @cancel="hideDialog"
    :title="$t('OpenMappingProject')"
    :id="modalName"
    @ok="selectItem"
    size="xl"
    :ok-title="$t('Open')"
    @shown="init"
    data-cy="channel-creator-mapping-project-open-modal">
    <div class="mapping-project-selector-dialog">
      <div v-if="!faulted">
        <div class="row">
          <div class="input-group filter-container col-lg-12">
            <input
              class="form-control"
              :placeholder="$t('Search')"
              v-model.lazy="filterText"
              type="text"
              ref="search"
              @keyup.enter="filterText = $refs.search.value"
              data-cy="channel-creator-open-mapping-project-search-txt" />
            <div class="input-group-append" v-if="filterText">
              <button class="btn btn-secondary" data-cy="clear-filter-button" type="button" @click="filterText = ''">
                <i class="mdp-Close"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-text">
          <b-tabs>
            <b-tab :title="$t('BaseMapping.CurrentCatalogue')" key="mappings" class="pt-3">
              <div class="card-text scrollable">
                <template v-for="(mappingTarget, targetIndex) in filteredCurrentMappingProjects" :key="'tab1-' + targetIndex">
                  <div>
                    <header class="d-flex accordion-header flex-row bg-white p-0 py-2 align-items-center">
                      <i
                        class="expander-btn pr-2"
                        :class="{
                          'mdp-ChevronBottom': expand,
                          'mdp-ChevronTop': !expand
                        }"
                        @click="$refs.targetGroup[targetIndex].toggle()"></i>
                      <h5 class="mb-0" block @click="$refs.targetGroup[targetIndex].toggle()">
                        {{ mappingTarget.targetSystemName }}
                      </h5>
                    </header>

                    <b-collapse :visible="expand" ref="targetGroup" role="tabpanel">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <th>{{ $t("BaseMapping.MappingProject") }}</th>
                            <th>{{ $t("UpdatedOn") }}</th>
                            <th>{{ $t("UpdatedBy") }}</th>
                            <th>{{ $t("CreatedOn") }}</th>
                            <th>{{ $t("CreatedBy") }}</th>
                          </tr>
                        </thead>
                        <tbody class="with-highlight">
                          <tr class="custom-tr"></tr>
                          <tr
                            v-for="(row, rowIndex) in mappingTarget.mappingProjects"
                            :key="targetIndex + '-' + rowIndex"
                            @click="selectRow(row, mappingTarget.targetSystemName)"
                            :class="{
                              'highlight-row': row.catalogMappingProjectId == selectedProject.catalogMappingProjectId
                            }">
                            <td>
                              {{ row.name }}
                            </td>
                            <td>
                              {{ this.$d(row.updatedOn, "shortDateTime") }}
                            </td>
                            <td>
                              {{ row.updatedBy }}
                            </td>
                            <td>
                              {{ this.$d(row.createdOn, "shortDateTime") }}
                            </td>
                            <td>
                              {{ row.createdBy }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-collapse>
                  </div>
                </template>
              </div>
            </b-tab>
            <b-tab key="allMappings" class="pt-3" v-if="isShowAllCatalogTab">
              <template #title>
                <span data-cy="channel-creator-open-mapping-project-all-catalog-tab">{{ $t("BaseMapping.AllCatalogue") }}</span>
              </template>
              <div class="card-text scrollable" data-cy="channel-creator-open-mapping-project-all-catalog-tab-content-div">
                <template v-for="(mappingTarget, targetIndex) in filteredMappingProjects" :key="'tab2-' + targetIndex">
                  <div>
                    <header class="d-flex accordion-header flex-row bg-white p-0 py-2 align-items-center">
                      <i
                        class="expander-btn pr-2"
                        :class="{
                          'mdp-ChevronBottom': expand,
                          'mdp-ChevronRight': !expand
                        }"
                        @click="$refs.targetGroupOfAll[targetIndex].toggle()"></i>
                      <h5 class="mb-0" block @click="$refs.targetGroupOfAll[targetIndex].toggle()">
                        {{ mappingTarget.targetSystemName }}
                      </h5>
                    </header>

                    <b-collapse :visible="expand" ref="targetGroupOfAll" role="tabpanel">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <th>{{ $t("BaseMapping.MappingProject") }}</th>
                            <th>{{ $t("Catalogue") }}</th>
                            <th>{{ $t("UpdatedOn") }}</th>
                            <th>{{ $t("UpdatedBy") }}</th>
                            <th>{{ $t("CreatedOn") }}</th>
                            <th>{{ $t("CreatedBy") }}</th>
                          </tr>
                        </thead>
                        <tbody class="with-highlight">
                          <tr class="custom-tr"></tr>
                          <tr
                            v-for="(row, rowIndex) in mappingTarget.mappingProjects"
                            :key="targetIndex + '-' + rowIndex"
                            @click="selectRow(row, mappingTarget.targetSystemName)"
                            :class="{
                              'highlight-row': row.catalogMappingProjectId == selectedProject.catalogMappingProjectId
                            }">
                            <td>
                              {{ row.name }}
                            </td>
                            <td>
                              {{ row.catalogName }}
                            </td>
                            <td>
                              {{ this.$d(row.updatedOn, "shortDateTime") }}
                            </td>
                            <td>
                              {{ row.updatedBy }}
                            </td>
                            <td>
                              {{ this.$d(row.createdOn, "shortDateTime") }}
                            </td>
                            <td>
                              {{ row.createdBy }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-collapse>
                  </div>
                </template>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>

      <div class="row" v-if="faulted">
        <div class="col-lg-12">
          <div class="alert alert-danger">{{ feedback }}</div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" :disabled="!selectedProject.catalogMappingProjectId" variant="primary" data-cy="channel-creator-open-mapping-project-ok-btn">
        {{ $t("Open") }}
      </b-btn>
      <b-btn @click="cancel" data-cy="channel-creator-open-mapping-project-cancel-btn">{{ $t("Cancel") }}</b-btn>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import("@assets/proton/style.css");
import catalogApi from "../../../services/catalogs";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    modalName: String,
    catalogId: String,
    isShowAllCatalogTab: {
      type: Boolean,
      default: true
    },
    targetSystemName: {
      type: [String, null],
      default: null
    }
  },
  data() {
    return {
      expand: true,
      faulted: false,
      feedback: "",
      currentMappingProjects: {},
      allMappingProjects: {},
      filterText: "",
      selectedProject: { catalogMappingProjectId: null, targetSystemName: "" },
      isOpen: false
    };
  },
  computed: {
    ...mapState("metadata", ["contentLanguages"]),
    ...mapState("channelCreator", ["mappingProjects", "selectedTargetCatalogId"]),

    filteredCurrentMappingProjects() {
      return this.getFilteredProjects(this.currentMappingProjects);
    },
    filteredMappingProjects() {
      return this.getFilteredProjects(this.allMappingProjects);
    },
    languageCode() {
      return this.contentLanguages.enabled[0].languageCode;
    }
  },
  components: {},
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("channelCreator", ["copyMappingProject"]),
    init() {
      this.loadMappingProjects();
    },
    getFilteredProjects: function (mappingProjects) {
      if (!this.filterText) return mappingProjects;

      const filterMatcher = (h, n) => h.some((i) => i.toLowerCase().includes(n.toLowerCase()));
      return mappingProjects
        .map((p) => {
          const project = { ...p };
          project.mappingProjects = project.mappingProjects.filter((x) => filterMatcher([x.name || "", x.catalogName || ""], this.filterText || ""));
          return project;
        })
        .filter((x) => x.mappingProjects.length);
    },
    loadMappingProjects: async function () {
      if (!this.catalogId) {
        this.currentMappingProjects = {};
        this.allMappingProjects = {};
      } else {
        try {
          const languageCode = this.contentLanguages.enabled[0].languageCode;
          const catalogMappingProjects = await catalogApi.getCatalogMappingProjects(this.catalogId, languageCode);
          if (this.targetSystemName) {
            this.currentMappingProjects = catalogMappingProjects.filter((x) => x.targetSystem === this.targetSystemName);
          } else {
            this.currentMappingProjects = catalogMappingProjects;
          }
          this.allMappingProjects = await catalogApi.getAllCatalogMappingProjects(languageCode);
        } catch (error) {
          this.faulted = true;
          this.feedback = error;
          console.error(error);
        }
      }
    },
    selectRow(project, targetSystemName) {
      this.selectedProject = project;
      this.selectedProject.targetSystemName = targetSystemName;
    },
    selectItem: async function () {
      const me = this;
      let mappingProject = null;

      if (this.selectedProject.catalogId == this.catalogId) {
        mappingProject = {
          catalogMappingProjectId: this.selectedProject.catalogMappingProjectId,
          catalogMappingTargetId: this.selectedProject.catalogMappingTargetId,
          name: this.selectedProject.name + " (" + this.selectedProject.targetSystemName + ")",
          targetSystemName: this.selectedProject.targetSystemName,
          targetSystem: this.selectedProject.targetSystem
        };
      } else {
        if (this.selectedProject.catalogMappingProjectId) {
          if (this.catalogId == this.selectedTargetCatalogId) {
            const catalogMappingProjectId = await this.copyMappingProject({
              catalogId: this.catalogId,
              catalogMappingProjectId: this.selectedProject.catalogMappingProjectId,
              languageCode: this.languageCode,
              targetSystemName: this.selectedProject.targetSystemName,
              catalogMappingTargetId: this.selectedProject.catalogMappingTargetId,
              targetSystem: this.selectedProject.targetSystem
            });
            mappingProject = this.mappingProjects.find((prj) => prj.catalogMappingProjectId == catalogMappingProjectId);
          } else {
            const newCatalogMappingProject = await catalogApi.copyMappingProject(
              this.catalogId,
              this.selectedProject.catalogMappingProjectId,
              this.languageCode
            );
            mappingProject = {
              catalogMappingProjectId: newCatalogMappingProject.catalogMappingProjectId,
              catalogMappingTargetId: this.selectedProject.catalogMappingTargetId,
              name: newCatalogMappingProject.name + " (" + this.selectedProject.targetSystemName + ")",
              targetSystemName: this.selectedProject.targetSystemName,
              targetSystem: this.selectedProject.targetSystem
            };
          }
        }
      }

      me.$emit("selectMappingProject", mappingProject);
      this.$emit("update:showDialog", false);
    },
    hideDialog() {
      this.$emit("update:showDialog", false);
    }
  },
  watch: {
    showDialog(nv) {
      this.isOpen = nv;
    }
  }
};
</script>
